module.exports = __webpack_public_path__ + "img/commun_three.5b3e8241.png";